/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/rules-of-hooks */
import "./shareDialog.scss";
import { useState, useEffect } from "react";
import { DialogTitle, DialogContent } from "@mui/material";
import UKDialog from "@/components/UKDialog";
import FacebookIcons from "@/assets/icons/facebook-icons.svg";
import TwitterIcon from "@/assets/icons/twitter-icon.svg";
import CopyLinkIcon from "@/assets/icons/copyLink-icon.svg";

import { CopyToClipboard } from "react-copy-to-clipboard";
import UKToast from "@/components/UKToast/index";;
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25158"
import { EXPCONFIG_FAST } from "@/constants/point";
import { useTranslation } from "@/i18n/client";
import SafeLink from "@/components/SafeLink";
// import WhatsAppSvg from "@/components/svg/whatsApp";
import WhatsAppSvg from "@/assets/icons/whatsApp.svg";
// import MassageSvg from "@/assets/icons/sms.svg";
import EmailSvg from "@/assets/icons/invite_email.svg";
// import TelegramSvg from "@/assets/icons/telegram.svg";

type Props = {
  open: boolean;
  isCodeType: boolean;
  closeFn: any;
  shareInfo: any;
  currency: any;
};

const DialogStyle = {
  "& .MuiDialog-paper": {
    width: "592px",
    margin: "0",
  },
  "& .MuiDialogTitle-root": {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "20px",
    padding: "20px 36px 20px 24px",
  },
};

const ContentStyle = {
  display: "flex",
  flexDirection: "column",
  padding: "24px 40px",
  paddingTop: "0",
};

export default function ShareDialog({ open, isCodeType, closeFn, shareInfo, currency }: Props) {

  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [couponInfo, setCouponInfo] = useState({
    awardType: 1,
    coupon_inviterRules: {
      discount: "",
      couponType: 1,
    },
    coupon_invitedRules: {
      discount: "",
    },
  });
  const shareTextWithLink = encodeURIComponent(`${shareInfo?.shareTitle} ${shareInfo?.activityShareUrl}`)
  const buttonNames = [
    t("profile.inviteFriend.sharePlatform.facebook"), 
    t("profile.inviteFriend.sharePlatform.tiktok"), 
    t("profile.inviteFriend.sharePlatform.wechat"), 
    t("profile.inviteFriend.sharePlatform.x"),
    t("profile.inviteFriend.sharePlatform.copyLink"),
  ];

  const coupon = shareInfo?.activityAwardRule?.inviterRules[0]?.activityAwards[0]?.coupon;
  const expoParams = {
    couponId: "-100",
    batchId: coupon?.batchId || "-100",
    couponSave: coupon?.discount || "-100",
    use_threshold: coupon?.quota || "-100",
    couponType: String(coupon?.couponType) || "-100",
    couponNum: "-100",
  }

  const closeHandler = () => {
    setIsOpen(false);
    closeFn && closeFn();
  };
  // 复制链接
  const shareCopyLink = () => {
    // 复制成功
    closeHandler();
    UKToast.show({
      content: t("profile.inviteFriend.copyTip"),
      icon: "success",
    });
    sendClickTrack.Activity_Yqyl_Share_Channel({button_name: buttonNames[4]});
  };
  // 分享到Twitter
  const shareToTwitter = () => {
    const url = `https://twitter.com/intent/tweet?button_hashtag=Joybuy&ref_src=twsrc%5Etfw&url=${shareInfo?.activityShareUrl}&text=${encodeURIComponent(shareInfo?.shareTitle)}`;
    // const url = `https://twitter.com/intent/tweet?button_hashtag=Joybuy&ref_src=twsrc%5Etfw&url=${shareInfo?.activityShareUrl}&text=${shareInfo?.shareTitle}`
    window.location.href = url;
    sendClickTrack.Activity_Yqyl_Share_Channel({button_name: buttonNames[3]});
  };
  // 分享到脸书
  const shareToFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${shareInfo?.activityShareUrl}`;
    window.location.href = url;
    sendClickTrack.Activity_Yqyl_Share_Channel({button_name: buttonNames[0]});
  };
  useEffect(() => {
    console.log("shareInfo=====", shareInfo);
    let inviterRules: any = {};
    let invitedRules: any = {};
    if (
      shareInfo?.activityAwardRule?.inviterRules &&
      shareInfo?.activityAwardRule?.inviterRules[0] &&
      shareInfo?.activityAwardRule?.inviterRules[0].activityAwards &&
      shareInfo?.activityAwardRule?.inviterRules[0].activityAwards[0]
    ) {
      inviterRules = shareInfo?.activityAwardRule?.inviterRules[0]?.activityAwards[0];
    }
    if (
      shareInfo?.activityAwardRule?.invitedRules &&
      shareInfo?.activityAwardRule?.invitedRules[0] &&
      shareInfo?.activityAwardRule?.invitedRules[0].activityAwards &&
      shareInfo?.activityAwardRule?.invitedRules[0].activityAwards[0]
    ) {
      invitedRules = shareInfo?.activityAwardRule?.invitedRules[0]?.activityAwards[0];
    }
    console.log("inviterRules======", inviterRules.coupon);
    console.log("invitedRules======", invitedRules.coupon);
    setCouponInfo({
      awardType: inviterRules?.awardType ? inviterRules.awardType : 1,
      coupon_inviterRules: inviterRules.coupon,
      coupon_invitedRules: invitedRules.coupon,
    });
  }, [shareInfo]);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <UKDialog open={isOpen} onClose={closeHandler} showCloseBtn={false} sx={DialogStyle}>
      <DialogTitle style={{ textAlign: "center" }}>
        {t("profile.inviteFriend.earnCoupon")}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={closeHandler}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={ContentStyle}>
        <div 
          className="contentWrap"
          exptag={"exp|" + EXPOSURE_RECORD.Activity_Yqyl_InviteExpo}
          data-exptag-config={EXPCONFIG_FAST}
          data-exptag-json-param={JSON.stringify(expoParams)}
        >
          <div
            className={`couponCard ${couponInfo?.coupon_inviterRules.couponType === 1 ? "redTheme" : "greenTheme"}`}
          >
            <span className="text-big fontJD">
              {currency}
              {couponInfo?.coupon_inviterRules?.discount
                ? parseInt(couponInfo?.coupon_inviterRules?.discount)
                : 0}{" "}
            </span>
            <span className="text-small">
              &nbsp;{couponInfo?.coupon_inviterRules.couponType === 1 ? t("coupon.onlyOff") : t("coupon.shippingOff")}
            </span>
          </div>
          <p className="titleCoupon">
            { t("profile.inviteFriend.winwin", { 
                currency, 
                discount: couponInfo?.coupon_invitedRules?.discount ? parseInt(couponInfo.coupon_invitedRules.discount) : 0 
              }
            )}
          </p>
          <div className="shareWrap">
          <SafeLink href={`https://api.whatsapp.com/send?text=${shareTextWithLink}`} passHref={true} rel="noopener noreferrer" target="_blank">
            <div className="shareItem">
                <WhatsAppSvg />
                <p className="ml12">WhatsApp</p>
              </div>                          
          </SafeLink>
            <div className="shareItem" onClick={shareToFacebook}>
              <FacebookIcons />
              {/* <p className="ml12">{t("profile.inviteFriend.sharePlatform.facebook")}</p> */}
              <p className="ml12">Facebook</p>
            </div>
            {/* <div className="shareItem">
                    <TiktokIcon></TiktokIcon>
                    <p className="ml12">{t("profile.inviteFriend.sharePlatform.tiktok")}</p>
                </div>
                <div className="shareItem">
                    <WechatIcons></WechatIcons>
                    <p className="ml12">{t("profile.inviteFriend.sharePlatform.wechat")}</p>
                </div> */}
            {/* <SafeLink href={`sms:?&body=${shareTextWithLink}`} passHref={true} rel="noopener noreferrer" target="_blank">
              <div className="shareItem">
                <MassageSvg />
                <p className="ml12">Message</p>
              </div>
            </SafeLink> */}
            <SafeLink href={`mailto:?subject=Joybuy&body=${shareTextWithLink}`} passHref={true} rel="noopener noreferrer" target="_blank">
              <div className="shareItem">
                <EmailSvg />
                <p className="ml12">{t("profile.inviteFriend.sharePlatform.email")}</p>
              </div>
            </SafeLink>
            <div className="shareItem" onClick={shareToTwitter}>
              <TwitterIcon />
            </div>
            {/* <SafeLink href={`https://telegram.me/share/url?url=${encodeURIComponent(shareInfo?.activityShareUrl)}&text=${encodeURIComponent(shareInfo?.shareTitle)}`} passHref={true} rel="noopener noreferrer" target="_blank">
              <div className="shareItem">
              <TelegramSvg />
                <p className="ml12">Telegram</p>
              </div>
            </SafeLink> */}
            
            <CopyToClipboard
              text={
                isCodeType
                  ? shareInfo?.shareTitle + shareInfo?.activityShareUrl
                  : shareInfo?.activityShareUrl
              }
              onCopy={shareCopyLink}
            >
              <div className="shareItem">
                <CopyLinkIcon />
                <p className="ml10">{isCodeType ? t("profile.inviteFriend.sharePlatform.copyCode") : t("profile.inviteFriend.sharePlatform.copyLink")}</p>
              </div>
            </CopyToClipboard>
          </div>
        </div>
      </DialogContent>
    </UKDialog>
  );
}
